"use strict";

var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["label", "isCurrent", "disabled", "element", "onClick", "stepIndexClassName"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _progressStepModule = _interopRequireDefault(require("./progress-step.module.scss"));
const ProgressStep = _ref => {
  let {
      label,
      isCurrent,
      disabled,
      element: Link = 'a',
      onClick,
      stepIndexClassName = ''
    } = _ref,
    step = _objectWithoutProperties(_ref, _excluded);
  const handleClick = e => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };
  return /*#__PURE__*/_react.default.createElement(Link, (0, _extends2.default)({
    className: (0, _classnames.default)({
      [_progressStepModule.default.StepDisabled]: disabled,
      [_progressStepModule.default.StepCurrent]: isCurrent,
      [_progressStepModule.default.Step]: !isCurrent
    }),
    "aria-disabled": disabled && !isCurrent,
    "aria-current": isCurrent && 'step'
  }, step, {
    tabIndex: isCurrent || disabled ? -1 : 0,
    onClick: handleClick
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_progressStepModule.default.stepIndex, stepIndexClassName)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _progressStepModule.default.stepLabel
  }, label)));
};
ProgressStep.defaultProps = {
  element: 'a'
};
var _default = exports.default = ProgressStep;